import trim from 'lodash/trim';
import upperFirst from 'lodash/upperFirst';
import includes from 'lodash/includes';
export function formatAddress(_ref) {
  var city = _ref.city,
      state = _ref.state,
      streetAddress = _ref.streetAddress,
      zipcode = _ref.zipcode;
  var COMPASS_DIRECTIONS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];

  var format = function format(value) {
    return (value || '').split(' ').map(function (word) {
      var casedWord = includes(COMPASS_DIRECTIONS, word) ? word.toUpperCase() : upperFirst(word.toLowerCase());
      return casedWord;
    }).join(' ');
  };

  return trim(format(streetAddress) + ", " + format(city) + ", " + (state || '') + " " + (zipcode || ''));
}
export var splitAddressLines = function splitAddressLines(address) {
  return [address.slice(0, address.indexOf(',')), address.slice(address.indexOf(',') + 2)];
};
//# sourceMappingURL=addressUtils.js.map